// extracted by mini-css-extract-plugin
export default {"ver-wrapper":"CollectorRewards_ver-wrapper__lSa0t","ver-list-divider":"CollectorRewards_ver-list-divider__IRcZq"};